import { Box, CircularProgress } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useStateValue } from '../../providers/StateProvider';
import { sendCodeForSISECI } from '../../services/auth';

export default function LoginCallback(): JSX.Element {
  const history = useHistory();
  const [, dispatch] = useStateValue();

  useEffect(() => {
    const url = (window as any).location.search;
    const query = new URLSearchParams(url);
    const code: any = query.get('code');
    if (code) {
      sendCodeForSISECI(code, history, dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box
      height="100hv"
      width="100hv"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress color="secondary" />
    </Box>
  );
}
